import { orgGuBookingList, orgGuidBookingCount, orgGuidListData } from '../../../../api/orgGuidAPI';
import errorHandle from '../../../../utils/errorHandle';

export const fetchGuideBookingData = async (selectedType, offSet, limit, setBookings, setLoading, selectedGuide) => {
    setLoading(true);
    try {
        const response = await orgGuBookingList(selectedType, limit, offSet, selectedGuide);
        setBookings(response.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchGuideBookingsCount = async (selectedType, setTotalCount, setLoading, selectedGuide) => {
    setLoading(true);
    try {
        const response = await orgGuidBookingCount(selectedType, selectedGuide);
        setTotalCount(response.data.bookCount);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchGuideListdata = async (selectedGuide, setGuidesData, setLoading) => {
    setLoading(true);
    try {
        const response = await orgGuidListData();
        setGuidesData(response.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
